import {
  AfterViewInit,
  ChangeDetectionStrategy,
  Component,
  DestroyRef,
  inject,
  Signal,
  viewChild,
} from '@angular/core';
import { PlatformService } from '@noda-lib/utils/services';
import { reviewsV2 } from '@pages/main/db/main.db';
import { IReview } from '@pages/main/interfaces/main.type';
import { ReviewsV2Imports } from '@pages/main/reviews-v2/reviews-v2.imports';
import type { SwiperOptions } from 'swiper';
import Swiper, { Autoplay, Pagination } from 'swiper';
import { SwiperComponent } from 'swiper/angular';

Swiper.use([Autoplay, Pagination]);

@Component({
  selector: 'noda-reviews-v2',
  standalone: true,
  templateUrl: './reviews-v2.component.html',
  styleUrls: ['./reviews-v2.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: ReviewsV2Imports,
})
export class ReviewsV2Component implements AfterViewInit {
  private destroyRef: DestroyRef = inject(DestroyRef);
  private platformService: PlatformService = inject(PlatformService);

  public config: SwiperOptions = {
    slidesPerView: 'auto',
    grabCursor: true,
    observer: true,
    observeParents: true,
    autoplay: false,
    pagination: {
      el: '.reviews-v2-pagination',
      clickable: true,
    },
    breakpoints: {
      320: {
        slidesOffsetBefore: 0,
        spaceBetween: 16,
        slidesOffsetAfter: 16,
        width: null,
      },
      768: {
        slidesOffsetBefore: 0,
        spaceBetween: 20,
        slidesOffsetAfter: 40,
        width: null,
      },
      1024: {
        slidesOffsetBefore: 0,
        spaceBetween: 20,
        slidesOffsetAfter: 48,
        width: null,
      },
      1440: {
        slidesOffsetBefore: 150,
        spaceBetween: 20,
        slidesOffsetAfter: 150,
        width: 1440,
      },
    },
  };
  public readonly reviews: IReview[] = reviewsV2;

  private swiper: Signal<SwiperComponent> = viewChild(SwiperComponent);

  ngAfterViewInit(): void {
    if (this.platformService.isBrowser()) {
      queueMicrotask(() => {
        this.initSwiperPagination();
      });
    }
  }

  private initSwiperPagination(): void {
    if (this.swiper()?.swiperRef) {
      const swiperRef = this.swiper().swiperRef;

      swiperRef.pagination.init();
      swiperRef.pagination.render();
      swiperRef.pagination.update();
      this.destroyRef.onDestroy(() => {
        swiperRef.destroy();
      });
    }
  }

  public getImagePath(item: string): string {
    return item ? `main/dating/avatars/${item}.webp` : '';
  }
}
